import React from 'react';
import { Link } from 'react-router-dom';

interface Service {
  title: string;
  description: string;
  icon: string;
  image?: string;
  imageAlt?: string;
  imagePosition?: string;
}

const ServicesOverview: React.FC = () => {
  const publicUrl = process.env.PUBLIC_URL || '';
  const services: Service[] = [
    {
      title: 'Exercise Physiology',
      description: 'Clinical exercise for MSK conditions, chronic pain, injury recovery, and long-term health. Delivered across London, Wimbledon, Fulham, Kensington, Chiswick, Surrey & Sussex.',
      icon: 'fas fa-heartbeat',
      image: 'ExerciseWarmUp.png',
      imageAlt: 'Clinical exercise physiology session',
      imagePosition: 'center 12%',
    },
    {
      title: 'Cancer Rehabilitation',
      description: 'Targeted oncology rehabilitation during and after treatment.',
      icon: 'fas fa-hand-holding-heart',
      image: 'OncolgyCare.JPG',
      imageAlt: 'Cancer rehabilitation',
    },
    {
      title: 'Lifestyle Management',
      description: 'Evidence-based programmes for metabolic health, stress, and chronic disease—tailored for busy executives and professionals.',
      icon: 'fas fa-balance-scale',
      image: 'TeamMember2.png',
      imageAlt: 'Lifestyle management',
      imagePosition: 'center 22%',
    },
    {
      title: 'Corporate Wellness',
      description: 'Expert-led talks and health programmes for organisations across London, Wimbledon, Fulham, Kensington, Chiswick, Surrey & Sussex.',
      icon: 'fas fa-microphone',
      image: 'Benspeaking.jpg',
      imageAlt: 'PH Therapy corporate speaking',
      imagePosition: 'center 12%'
    },

  ];

  return (
    <section id="services" className="services-home">
      <div className="container">
        <h2 className="services-home-title">Our Services</h2>
        <div className="services-home-grid">
          {services.map((service, index) => (
            <article key={index} className="service-card">
              {service.image && (
                <div className="service-card-image-wrapper">
                  <img
                    src={service.image.startsWith('http') ? service.image : `${publicUrl}/${service.image}`}
                    alt={service.imageAlt || service.title}
                    className="service-card-image"
                    style={service.imagePosition ? { objectPosition: service.imagePosition } : undefined}
                  />
                </div>
              )}
              <div className="service-card-icon">
                <i className={service.icon} aria-hidden="true" />
              </div>
              <h3>{service.title}</h3>
              <p>{service.description}</p>
              <Link to="/services" className="service-card-link">
                Learn more <i className="fas fa-arrow-right" aria-hidden="true" />
              </Link>
            </article>
          ))}
        </div>
        <Link to="/services" className="services-home-cta">View all services</Link>
      </div>
    </section>
  );
};

export default ServicesOverview;
